class LoyaltyApi {
  constructor(ctx) {
    this.ctx = ctx;
  }

  getLoyaltyConfig = async () => {
    const res = await this.ctx.get('/loyalty/config/');

    return res.data;
  };

  getBonusesTransactions = async (params) => {
    const res = await this.ctx.get('/loyalty/bonuses_transactions/', params);

    return res.data;
  };

  getGifts = async () => {
    const res = await this.ctx.get('/loyalty/gifts/');

    return res.data;
  };

  buyGift = async (params) => {
    const res = await this.ctx.post('/loyalty/gifts/buy/', params);

    return res.data;
  };
}

export default LoyaltyApi;
